/** Where "Attach from file" reads from — a customer file (dept inboxes, Customer File) or an application (applications@). */
import { appInboxListFiles, appInboxSearchApps } from "@/lib/api";
import { stageLabel } from "@/pages/inbox/CasePicker";

export const caseFileSource = (api) => ({
  kind: "case_file",
  noun: "customer file",
  placeholder: "Search SF-27512, company or director",
  label: (s) => `${s.sf || "—"} · ${s.customer_name || ""}`,
  short: (s) => s.sf || s.customer_name || "file",
  list: (s) => api.listFiles(s.case_id),
  search: async (q) => ((await api.searchCases(q)).matches || []).map((m) => ({ sf: m.sf, name: m.customer_name, badge: stageLabel(m), scope: { case_id: m.case_id, sf: m.sf, customer_name: m.customer_name } })),
});

export const caseScope = (c) => (c ? { case_id: c.case_id, sf: c.sf, customer_name: c.customer_name } : null);

export const appFileSource = () => ({
  kind: "app_file",
  noun: "application",
  placeholder: "Search SF-27512 or company name",
  label: (s) => `${s.sf || "—"} · ${s.name || ""}`,
  short: (s) => s.sf || s.name || "application",
  list: (s) => appInboxListFiles(s.sf, s.item_id),
  search: async (q) => ((await appInboxSearchApps(q)).matches || []).filter((m) => m.sf || m.item_id)
    .map((m) => ({ sf: m.sf, name: m.name || m.customer_name, badge: m.status, scope: { sf: m.sf, item_id: m.item_id, name: m.name || m.customer_name } })),
});

export const appScope = (a) => (a ? { sf: a.sf, item_id: a.item_id, name: a.name || a.customer_name } : null);
